export default "__VITE_ASSET__B9zSJX0N__"